export default "__VITE_ASSET__2be6730f__"